const LayerUpSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        d="M23.4375 19.2708H15.1041V9.37495H17.186C17.3762 9.37506 17.5628 9.32308 17.7256 9.22465C17.8884 9.12621 18.0211 8.98508 18.1094 8.81656C18.1976 8.64804 18.2381 8.45857 18.2263 8.26871C18.2145 8.07884 18.1509 7.89583 18.0425 7.73953L13.3575 0.969893C13.2616 0.831243 13.1334 0.717928 12.9841 0.639661C12.8347 0.561393 12.6686 0.520508 12.5 0.520508C12.3314 0.520508 12.1653 0.561393 12.0159 0.639661C11.8665 0.717928 11.7384 0.831243 11.6424 0.969893L6.95748 7.73953C6.84918 7.89586 6.78573 8.07885 6.77401 8.26867C6.76228 8.45848 6.80273 8.64789 6.89096 8.81636C6.97919 8.98484 7.11185 9.12595 7.27456 9.22441C7.43726 9.32288 7.62381 9.37493 7.81399 9.37495H9.89581V19.2708H1.56248C1.28631 19.2711 1.02154 19.3809 0.82626 19.5762C0.630979 19.7715 0.52113 20.0363 0.520813 20.3124V23.4374C0.52113 23.7136 0.630979 23.9784 0.82626 24.1737C1.02154 24.3689 1.28631 24.4788 1.56248 24.4791H23.4375C23.7136 24.4788 23.9784 24.3689 24.1737 24.1737C24.369 23.9784 24.4788 23.7136 24.4791 23.4374V20.3124C24.4788 20.0363 24.369 19.7715 24.1737 19.5762C23.9784 19.3809 23.7136 19.2711 23.4375 19.2708Z"
        fill="black"
        fillOpacity="0.95"
      />
    </svg>
  );
};

export default LayerUpSvg;
